import React from "react";

const ConnectButton = () => {
    return (
        <a className="connect-btn" href="https://calendly.com/higherlowfilms/30min" target="_blank" rel="noopener noreferrer">
            <span>
                Connect
            </span>
        </a>
    );
};

export default ConnectButton;
